import { Button, Form, Input, Typography, Modal } from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NavContext } from "../../state/NavContext";
import { SideContext } from "../../state/SideContext";
import { UserContext } from "../../state/UserContext";

const { Title } = Typography;

const ChangePassword = () => {
  const { user } = useContext(UserContext);
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);
  const { setSideIndex } = useContext(SideContext);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setSideIndex("change-password");
    setActiveIndex("admin");
    setIsSideBarActive(true);
  }, [setActiveIndex, setIsSideBarActive, setSideIndex]);

  const onFinish = (values) => {
    setIsLoading(true);

    console.log(user.token);
    console.log(values);

    const { oldpassword, password, confpassword } = values;

    axios
      .post(
        "https://backendexample.sanbersy.com/api/change-password",
        {
          current_password: oldpassword,
          new_password: password,
          new_confirm_password: confpassword,
        },
        { headers: { Authorization: "Bearer " + user.token } }
      )
      .then((res) => {
        setIsLoading(false);
        Modal.success({
          title: "Success",
          content: "Change password success. New password saved.",
        });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err.response);

        Modal.error({
          title: "Failed",
          content: `Change password failed, please provide valid old password`,
        });
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <div style={{ width: "100%", background: "white", padding: 24 }}>
        <Title level={2}>Change Password</Title>
        <Form
          name="basic"
          layout="vertical"
          wrapperCol={{ span: 24 }}
          initialValues={{ remember: false }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="oldpassword"
            label="old password"
            rules={[
              { required: true, message: "Please input your old password!" },
              {
                min: 6,
                message: "password must be at least 6 characters",
              },
            ]}
          >
            <Input.Password placeholder="Input your old password" />
          </Form.Item>

          <Form.Item
            name="password"
            label="new password"
            rules={[
              { required: true, message: "Please input your new password!" },
              {
                min: 6,
                message: "password must be at least 6 characters",
              },
            ]}
          >
            <Input.Password placeholder="Input your new password" />
          </Form.Item>

          <Form.Item
            name="confpassword"
            label="confirmation password"
            rules={[
              {
                required: true,
                message: "Please input your confirmation password!",
              },
              {
                min: 6,
                message: "password must be at least 6 characters",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "The two passwords that you entered do not match!"
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="Input your confirmation password" />
          </Form.Item>

          <Form.Item wrapperCol={{ span: 24 }}>
            <Button type="primary" htmlType="submit" block loading={isLoading}>
              Change Password
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default ChangePassword;
